import { useQuery } from '@tanstack/react-query'
import { GETUserAppeals } from './user_appeals.requests'

export const GET_APPEALS_QUERY_KEY = ['appeals']

export const useAppeals = () => {
  return useQuery({
    queryKey: GET_APPEALS_QUERY_KEY,
    queryFn: async () => await GETUserAppeals(),
  })
}
